import axios from 'axios';
import { API_URL } from './runtimeConfig';

const axiosInstance = axios.create({
	baseURL: API_URL
});

// Attach the login token to every request (read per request so pages opened directly,
// before the app context has loaded, still authenticate).
axiosInstance.interceptors.request.use((config) => {
	const token = localStorage.getItem('ah_token');
	if (token && !config.headers.Authorization) config.headers.Authorization = token;
	return config;
});

axiosInstance.interceptors.response.use(
	(response) => response,
	(error) => {
		const url = (error.config && error.config.url) || '';
		// The API says our token is no good (expired / staff removed): sign out and show the login page.
		if (error.response && error.response.status === 401 && !/\/auth\/(login|me)$/.test(url) && localStorage.getItem('ah_token')) {
			localStorage.removeItem('ah_token');
			window.location.assign('/');
		}
		return Promise.reject((error.response && error.response.data) || 'Something went wrong');
	}
);

export default axiosInstance;
